
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Versionsvergleich from "../pages/versionsvergleich/page";
import PreisePage from '../pages/preise/page';
import ShopPage from '../pages/shop/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/preise',
    element: <PreisePage />,
  },
  {
    path: '/versionsvergleich',
    element: <Versionsvergleich />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
